import React, { Component } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from "react-router-dom";
import { StyleSheetManager, ThemeProvider } from "styled-components";

import { DomManipulatorProvider } from "../contexts/domManipulator/DomManipulatorProvider";
import { GlobalStyle } from "../global.style";
import { shouldForwardProp } from "../global.utils";
import {
    ROUTE_EMAIL_CONFIRM,
    ROUTE_LOGIN,
    ROUTE_LOGIN_DEVICE,
    ROUTE_LOGIN_INVITATION,
    ROUTE_LOGIN_REGISTER,
    ROUTE_LOGIN_RESET_PASS,
    ROUTE_LOGIN_RESET_PASS_REQUEST,
    ROUTE_LOGIN_TENANT,
    ROUTE_LOGIN_TENANT_REGISTER,
    ROUTE_LOGIN_VERIFY
} from "../routes";
import { themes } from "../theme";
import DevicePicker from "./DevicePicker";
import EmailConfirm from "./EmailConfirm";
import Invitation from "./Invitation";
import Login from "./Login";
import LoginPage from "./LoginPage";
import Register from "./Register";
import ResetPassword from "./ResetPassword";
import ResetPasswordRequest from "./ResetPasswordRequest";
import store from "./state/store";
import TenantPicker from "./TenantPicker";
import TenantRegister from "./TenantRegister";
import Verify from "./Verify";


interface IProps extends RouteComponentProps, WithTranslation {
}

class Router extends Component<IProps> {
    render() {
        if (!this.props.tReady) {
            return null;
        }
        return (
            <Provider store={store}>
                <DomManipulatorProvider>
                    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                        <ThemeProvider theme={themes.light}>
                            <GlobalStyle theme={themes.light}/>
                            <LoginPage>
                                <Switch>
                                    <Route exact path={ROUTE_LOGIN} component={Login}/>
                                    <Route path={ROUTE_LOGIN_REGISTER} component={Register}/>
                                    <Route path={ROUTE_EMAIL_CONFIRM} component={EmailConfirm}/>
                                    <Route path={`${ROUTE_LOGIN_VERIFY}/:code`} component={Verify}/>
                                    <Route path={ROUTE_LOGIN_TENANT} component={TenantPicker}/>
                                    <Route path={`${ROUTE_LOGIN_INVITATION}/:code`} component={Invitation}/>
                                    <Route path={ROUTE_LOGIN_TENANT_REGISTER} component={TenantRegister}/>
                                    <Route path={ROUTE_LOGIN_DEVICE} component={DevicePicker}/>
                                    <Route path={`${ROUTE_LOGIN_RESET_PASS}/:code`} component={ResetPassword}/>
                                    <Route path={ROUTE_LOGIN_RESET_PASS_REQUEST} component={ResetPasswordRequest}/>
                                    {/*wrong url, redirect to log in */}
                                    <Redirect to={ROUTE_LOGIN}/>
                                </Switch>
                            </LoginPage>
                        </ThemeProvider>
                    </StyleSheetManager>
                </DomManipulatorProvider>
            </Provider>
        );
    }
}

export default withRouter(withTranslation(["Login", "Common", "Components"])(Router));
